module.exports = __webpack_public_path__ + "img/home-fixed-investment.73432d77.svg";